module.exports = __webpack_public_path__ + "img/card_bg2@2x.2c7b1ff7.png";